import { CircularProgress, Stack, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { AssignTellerTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";
import DeleteIcon from '@mui/icons-material/Delete';
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const AssignTellerTable: React.FC<AssignTellerTablePropsType> = ({ rows, handleItemClick, selectedTellerId }) => {
    const assignTellerTableHeaders = ["Till Number", "Teller Name", "Branch", "Posting Limit", "Action"];

    return (
        <BaseTable headers={assignTellerTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.tillNumber}</TableCell>
                            <TableCell>{row?.name}</TableCell>
                            <TableCell>{row?.branch}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.postingLimit)}</TableCell>
                            <TableCell>
                                <Stack direction="row" gap="calc(var(--flex-gap)/4)">
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick(e, row.id, "edit")}
                                    >
                                        Edit
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick?.(e, { tellerId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {selectedTellerId !== null && selectedTellerId === row.id ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
